export default {
  header: ['D pol', 'fpp', 'Ø furo'],
  data: [
    ['1/8', '28', '8,8'],
    ['1/4', '19', '11,8'],
    ['3/8', '19', '15,3'],
    ['1/2', '14', '19'],
    ['5/8', '14', '21'],
    ['3/4', '14', '24,5'],
    ['7/8', '14', '28,3'],
    ['1”', '11', '30,8'],
    ['1” 1/8', '11', '35,3'],
    ['1” 1/4', '11', '39,3'],
    ['1” 3/8', '11', '41,7'],
    ['1” 1/2', '11', '45,2'],
    ['1” 3/4', '11', '51,1'],
    ['2”', '11', '57'],
    ['2” 1/4', '11', '63,1'],
    ['2” 1/2', '11', '72,6'],
  ],
};
